export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8671.a5a6641e.jpg";